module.exports = __webpack_public_path__ + "media/src/ui/icons/link-img-65311efb4ea013eb57a3839db32748f7.png";